export const movies = [
  {
    id: "viva-erotica-1996",
    title: "色情男女",
    titleEn: "Viva Erotica",
    year: 1996,
    decade: "1990s",
    director: "尔冬升",
    cast: ["张国荣", "莫文蔚", "舒淇", "罗家英"],
    genre: ["剧情", "喜剧"],
    rating: 7.1,
    runtime: 108,
    region: "香港",
    tags: ["行业题材", "金像奖", "戏中戏"],
    synopsis: "一部以电影行业幕后为背景的作品，讲述一位陷入创作低谷的导演如何在商业与艺术之间寻找平衡。",
    plot:
      "影片以戏中戏结构展开，主角是一位曾经被寄予厚望却接连失利的年轻导演。为了生计，他被迫接下一部低成本类型片的拍摄工作，在片场与投资人、演员、制片人之间周旋。过程中他逐渐重新审视「电影」二字的意义，也在喧闹与荒诞中找回对创作的初心。作品以轻松幽默的笔触描摹行业生态，是该类型中少见的自我观照之作，其表演与剧本曾获香港电影金像奖多项肯定。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%201990s%20Hong%20Kong%20cinema%20art%20poster%2C%20stylized%20abstract%20film%20reel%20and%20spotlight%20composition%2C%20deep%20crimson%20and%20warm%20gold%20tones%2C%20textured%20aged%20paper%20grain%2C%20moody%20film%20noir%20lighting%2C%20movie%20archive%20aesthetic%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-01&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=retro%20film%20set%20with%20vintage%20camera%20and%20studio%20lights%2C%20warm%20amber%20and%20crimson%20color%20grading%2C%20cinematic%20behind%20the%20scenes%20atmosphere%2C%20soft%20grain%2C%20artistic%20wide%20shot%2C%20no%20people%20faces&width=1200&height=675&seq=movie-still-01&orientation=landscape",
    featured: true,
  },
  {
    id: "fruit-is-ripe-1993",
    title: "蜜桃成熟时",
    titleEn: "Fruit Is Ripe",
    year: 1993,
    decade: "1990s",
    director: "张肇麟",
    cast: ["李丽珍", "潘震伟", "成奎安", "黄一山"],
    genre: ["剧情", "爱情"],
    rating: 5.6,
    runtime: 92,
    region: "香港",
    tags: ["青春", "夏日", "都市爱情"],
    synopsis: "一段发生在盛夏都市中的青春情感故事，以轻快的节奏描绘年轻人对爱情与成长的理解。",
    plot:
      "故事围绕几位年轻人在一个炎热夏天里的相遇与相处展开。女主角在成长与情感的十字路口徘徊，与身边人物产生一系列轻松而细腻的互动。影片以阳光、海滩与城市街景为舞台，配以流行曲风的配乐，构成鲜明的九十年代都市气息。它是当时青春题材类型片的代表之一，也因演员的清新形象而为人所记住。",
    cover:
      "https://readdy.ai/api/search-image?query=summer%20themed%20vintage%20film%20poster%2C%20stylized%20illustration%20of%20sunset%20beach%20and%20palm%20leaves%2C%20warm%20amber%20orange%20and%20cream%20tones%2C%20retro%20nineteen%20nineties%20pop%20art%20texture%2C%20soft%20paper%20grain%2C%20vertical%20poster%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-02&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=sunny%20summer%20city%20waterfront%20in%20nineteen%20nineties%20Hong%20Kong%2C%20warm%20golden%20hour%20light%2C%20nostalgic%20film%20grain%2C%20soft%20pastel%20amber%20tones%2C%20artistic%20landscape%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-02&orientation=landscape",
    featured: true,
  },
  {
    id: "sex-and-zen-1991",
    title: "玉蒲团之偷情宝鉴",
    titleEn: "Sex and Zen",
    year: 1991,
    decade: "1990s",
    director: "麦当雄",
    cast: ["叶子楣", "吴启华", "周弘", "徐锦江"],
    genre: ["古装", "喜剧"],
    rating: 6.1,
    runtime: 99,
    region: "香港",
    tags: ["古装", "民间故事", "票房话题"],
    synopsis: "取材自古典民间故事的古装作品，以夸张喜剧手法勾勒市井百态与人性欲望。",
    plot:
      "影片改编自流传已久的古典笔记故事，讲述一名书生在功名与情感之间的曲折经历。作品以古装布景、夸张表演与市井幽默构建出一个亦庄亦谐的世界，既有对人情世故的调侃，也包含对欲望与代价的寓言式表达。上映后引发广泛讨论，成为该年代最具话题性的类型片之一，也推动了后续同类题材的制作风潮。",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20Chinese%20costume%20drama%20vintage%20poster%2C%20stylized%20ornate%20red%20lantern%20and%20silk%20scroll%20motif%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20textured%20rice%20paper%20grain%2C%20traditional%20painting%20inspired%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-03&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=ancient%20Chinese%20chamber%20interior%20with%20red%20silk%20drapery%20and%20candlelight%2C%20warm%20crimson%20and%20gold%20tones%2C%20cinematic%20costume%20drama%20set%2C%20film%20grain%2C%20artistic%20wide%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-03&orientation=landscape",
    featured: true,
  },
  {
    id: "the-untold-story-1993",
    title: "八仙饭店之人肉叉烧包",
    titleEn: "The Untold Story",
    year: 1993,
    decade: "1990s",
    director: "陈庆嘉",
    cast: ["黄秋生", "李修贤", "关宝慧", "成奎安"],
    genre: ["犯罪", "惊悚"],
    rating: 7.0,
    runtime: 96,
    region: "香港",
    tags: ["奇案改编", "犯罪档案", "影帝之作"],
    synopsis: "改编自真实社会案件的犯罪题材作品，以纪实视角还原一宗轰动全城的刑事案件。",
    plot:
      "影片以香港一宗广为人知的真实案件为蓝本，采用近乎纪实的叙事手法，从案件的发生、侦查到审理层层推进。导演刻意淡化戏剧化处理，转而通过冷静的镜头与写实的场景营造压抑氛围。主演以极具张力的表演塑造出一个令人不寒而栗的角色，凭此获得香港电影金像奖最佳男主角，成为其表演生涯的代表作之一。",
    cover:
      "https://readdy.ai/api/search-image?query=crime%20thriller%20vintage%20film%20poster%2C%20stylized%20dark%20alley%20with%20single%20streetlamp%2C%20desaturated%20charcoal%20grey%20with%20crimson%20accent%2C%20gritty%20textured%20paper%2C%20moody%20noir%20shadow%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-04&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=rainy%20night%20old%20Hong%20Kong%20street%20alley%20with%20neon%20signs%2C%20desaturated%20grey%20and%20faint%20crimson%20tones%2C%20crime%20film%20atmosphere%2C%20film%20noir%20lighting%2C%20grain%2C%20artistic%20wide%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-04&orientation=landscape",
    featured: false,
  },
  {
    id: "dr-lamb-1992",
    title: "羔羊医生",
    titleEn: "Dr. Lamb",
    year: 1992,
    decade: "1990s",
    director: "李修贤",
    cast: ["任达华", "李修贤", "郑则仕", "关宝慧"],
    genre: ["犯罪", "惊悚"],
    rating: 6.3,
    runtime: 94,
    region: "香港",
    tags: ["奇案改编", "警匪", "纪实"],
    synopsis: "以真实案件为灵感的警匪犯罪片，聚焦罪案侦查过程与人物心理刻画。",
    plot:
      "故事以一宗扑朔迷离的连环案件为线索，警方在抽丝剥茧的调查中逐渐逼近真相。影片将大量篇幅用于刻画嫌疑人与警探之间的心理角力，通过审讯室与案发现场的交替叙事营造紧张感。它延续了九十年代香港纪实犯罪片的创作传统，是研究该类型片叙事手法的重要样本。",
    cover:
      "https://readdy.ai/api/search-image?query=police%20crime%20film%20vintage%20poster%2C%20stylized%20interrogation%20room%20silhouette%20and%20hanging%20lamp%2C%20cold%20grey%20with%20dim%20amber%20glow%2C%20gritty%20textured%20surface%2C%20noir%20shadow%20play%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-05&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=dim%20police%20interrogation%20room%20with%20single%20overhead%20lamp%20and%20mirror%2C%20cold%20grey%20and%20amber%20tones%2C%20crime%20thriller%20set%2C%20film%20grain%2C%20artistic%20wide%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-05&orientation=landscape",
    featured: false,
  },
  {
    id: "i-am-frantic-1994",
    title: "我为卿狂",
    titleEn: "I Am Frantic",
    year: 1994,
    decade: "1990s",
    director: "查传谊",
    cast: ["任达华", "翁虹", "吴启华", "叶子楣"],
    genre: ["剧情", "爱情"],
    rating: 5.2,
    runtime: 90,
    region: "香港",
    tags: ["都市", "情感纠葛", "九十年代"],
    synopsis: "一部聚焦都市男女情感关系的剧情片，探讨承诺、欲望与自我认同的拉扯。",
    plot:
      "影片以几位都市男女的交错关系为主线，通过多线叙事呈现当代人际关系的复杂面貌。角色在爱情、事业与内心欲望之间反复摇摆，导演以都市夜景与室内空间的对比强化情绪张力。作品反映了九十年代香港社会在快速变迁中的情感焦虑，是研究当年都市题材的参考之作。",
    cover:
      "https://readdy.ai/api/search-image?query=urban%20romance%20vintage%20film%20poster%2C%20stylized%20rainy%20night%20city%20with%20reflected%20neon%2C%20deep%20crimson%20and%20muted%20grey%20tones%2C%20textured%20grainy%20paper%2C%20melancholic%20mood%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-06&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=rainy%20night%20city%20street%20with%20wet%20reflections%20and%20neon%20glow%2C%20crimson%20and%20charcoal%20tones%2C%20melancholic%20romance%20film%20atmosphere%2C%20film%20grain%2C%20artistic%20wide%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-06&orientation=landscape",
    featured: false,
  },
  {
    id: "call-girl-92-1992",
    title: "现代应召女郎",
    titleEn: "Call Girl '92",
    year: 1992,
    decade: "1990s",
    director: "黄志",
    cast: ["叶玉卿", "郑裕玲", "吴家丽", "张坚庭"],
    genre: ["剧情"],
    rating: 6.0,
    runtime: 96,
    region: "香港",
    tags: ["社会写实", "群像", "都市"],
    synopsis: "以群像结构描绘都市边缘女性生存状态的社会写实剧情片。",
    plot:
      "影片通过数条并行的女性故事线，呈现都市中不同出身与处境的女性如何面对生活压力与人生选择。导演以克制而写实的镜头语言，避免猎奇，转而关注人物的情感与尊严。多位女演员的表演为影片增添层次，使其在同类题材中显得格外注重人文关怀。",
    cover:
      "https://readdy.ai/api/search-image?query=social%20drama%20vintage%20film%20poster%2C%20stylized%20city%20skyline%20at%20dusk%20with%20lone%20figure%20silhouette%2C%20muted%20crimson%20and%20warm%20grey%20tones%2C%20textured%20aged%20paper%2C%20restrained%20melancholy%20mood%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-07&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=nineteen%20nineties%20Hong%20Kong%20dense%20city%20skyline%20at%20dusk%2C%20muted%20crimson%20and%20grey%20tones%2C%20social%20drama%20atmosphere%2C%20soft%20film%20grain%2C%20artistic%20wide%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-07&orientation=landscape",
    featured: false,
  },
  {
    id: "lady-in-the-dark-1994",
    title: "靛夫人",
    titleEn: "Lady in the Dark",
    year: 1994,
    decade: "1990s",
    director: "陈奥图",
    cast: ["翁虹", "吴启华", "郑浩南", "麦家琪"],
    genre: ["古装", "剧情"],
    rating: 5.8,
    runtime: 89,
    region: "香港",
    tags: ["古装", "传奇", "系列作品"],
    synopsis: "承接古装民间传奇脉络的系列作品，以传奇故事包裹对人性的描摹。",
    plot:
      "影片以古代社会为背景，讲述一位身世曲折的女性在乱世中周旋求生的故事。作品延续了古典传奇的叙事框架，用华丽布景与类型化的情节结构吸引观众，同时在人物动机上做出一定挖掘。作为系列作品的一环，它帮助确立了九十年代古装类型片的固定观众群。",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20legend%20vintage%20poster%2C%20stylized%20indigo%20night%20with%20moon%20and%20ornate%20palace%20roof%2C%20deep%20indigo%20and%20antique%20gold%20accents%2C%20textured%20silk%20paper%2C%20mysterious%20oriental%20mood%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-08&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=ornate%20ancient%20Chinese%20palace%20hall%20at%20night%20with%20lanterns%2C%20deep%20indigo%20and%20gold%20tones%2C%20cinematic%20costume%20drama%20set%2C%20soft%20film%20grain%2C%20artistic%20wide%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-08&orientation=landscape",
    featured: false,
  },
  {
    id: "temptation-summary-1993",
    title: "三度诱惑",
    titleEn: "Temptation Summary",
    year: 1993,
    decade: "1990s",
    director: "何藩",
    cast: ["李华月", "徐锦江", "黄一山", "苑琼丹"],
    genre: ["剧情", "喜剧"],
    rating: 5.4,
    runtime: 91,
    region: "香港",
    tags: ["分段式", "都市", "轻松"],
    synopsis: "采用分段式结构的三段都市故事，以轻松诙谐的方式讲述都市人的欲望与际遇。",
    plot:
      "影片由三个相对独立又互有呼应的短篇组成，分别从不同角度切入都市人的情感与生活。导演以明快的节奏与生活化的对白营造轻松氛围，喜剧演员的加盟令整体基调偏向市井趣味。分段式结构使影片在叙事上更为灵活，也是该年代类型片常见的组织方式。",
    cover:
      "https://readdy.ai/api/search-image?query=anthology%20comedy%20vintage%20poster%2C%20stylized%20triptych%20of%20city%20windows%20and%20abstract%20shapes%2C%20warm%20amber%20and%20cream%20with%20crimson%20accents%2C%20retro%20pop%20texture%2C%20playful%20mood%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-09&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cozy%20nineteen%20nineties%20city%20apartment%20interior%20at%20dusk%20with%20warm%20light%2C%20amber%20and%20cream%20tones%2C%20light%20comedy%20set%2C%20soft%20film%20grain%2C%20artistic%20wide%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-09&orientation=landscape",
    featured: false,
  },
  {
    id: "midnight-one-oclock-1995",
    title: "夜半一点钟",
    titleEn: "Midnight One O'Clock",
    year: 1995,
    decade: "1990s",
    director: "钱永强",
    cast: ["任达华", "黄秋生", "邱淑贞", "吴家丽"],
    genre: ["惊悚", "灵异"],
    rating: 5.9,
    runtime: 92,
    region: "香港",
    tags: ["分段式", "灵异", "都市传说"],
    synopsis: "三段式灵异惊悚作品，围绕深夜都市中流传的诡异传闻展开。",
    plot:
      "影片由三个独立成章又主题呼应的灵异故事组成，场景多设定在深夜的都市空间。导演擅长以光影与音效制造悬念，将都市传说转化为银幕上的紧张体验。作品是九十年代灵异类型片的代表作之一，对后来的同类创作产生了一定影响。",
    cover:
      "https://readdy.ai/api/search-image?query=supernatural%20horror%20vintage%20poster%2C%20stylized%20midnight%20clock%20tower%20and%20misty%20street%2C%20cold%20teal%20grey%20with%20faint%20amber%20glow%2C%20eerie%20textured%20paper%20grain%2C%20mysterious%20mood%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-10&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=empty%20misty%20city%20street%20at%20midnight%20with%20dim%20streetlamps%2C%20cold%20grey%20and%20faint%20amber%20tones%2C%20eerie%20supernatural%20atmosphere%2C%20film%20grain%2C%20artistic%20wide%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-10&orientation=landscape",
    featured: false,
  },
  {
    id: "royal-tramp-1994",
    title: "大内密探之零零性性",
    titleEn: "Royal Tramp Comedy",
    year: 1994,
    decade: "1990s",
    director: "黎继明",
    cast: ["徐锦江", "苑琼丹", "黄一山", "吴孟达"],
    genre: ["古装", "喜剧"],
    rating: 5.7,
    runtime: 88,
    region: "香港",
    tags: ["古装喜剧", "恶搞", "无厘头"],
    synopsis: "无厘头风格的古装喜剧，以夸张桥段调侃宫廷与江湖题材。",
    plot:
      "影片借古装宫廷背景展开，用大量夸张对白与荒诞桥段编织笑料，是九十年代无厘头喜剧潮流的产物之一。导演在类型框架内玩转武侠与宫廷元素，配合群戏演员的喜剧节奏，形成轻松解压的观影体验。作品反映了当年香港类型片快速跟风、娱乐至上的市场生态。",
    cover:
      "https://readdy.ai/api/search-image?query=wuxia%20comedy%20vintage%20poster%2C%20stylized%20ancient%20Chinese%20armor%20and%20folding%20fan%20motif%2C%20bold%20crimson%20gold%20and%20jade%20green%20accents%2C%20retro%20pop%20art%20texture%2C%20playful%20energetic%20mood%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-11&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=colorful%20ancient%20Chinese%20courtyard%20with%20red%20pillars%20and%20gold%20ornaments%2C%20bold%20warm%20tones%2C%20comedic%20costume%20drama%20set%2C%20soft%20film%20grain%2C%20artistic%20wide%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-11&orientation=landscape",
    featured: false,
  },
  {
    id: "dangerous-liaison-1993",
    title: "危情",
    titleEn: "Dangerous Liaison",
    year: 1993,
    decade: "1990s",
    director: "张肇麟",
    cast: ["郑浩南", "彭丹", "吴家丽", "林国斌"],
    genre: ["剧情", "爱情", "惊悚"],
    rating: 5.5,
    runtime: 93,
    region: "香港",
    tags: ["悬疑爱情", "都市", "反转"],
    synopsis: "融合爱情与悬疑元素的作品，在亲密关系的外壳下埋藏层层反转。",
    plot:
      "影片以一桩看似寻常的都市情感关系切入，随着剧情推进逐渐揭开隐藏其中的秘密与利益纠葛。导演以冷峻的色调与克制的叙事营造悬念，将爱情片与惊悚片的手法加以融合。作品体现了九十年代香港类型片在题材融合上的尝试。",
    cover:
      "https://readdy.ai/api/search-image?query=mystery%20romance%20vintage%20poster%2C%20stylized%20two%20entwined%20silhouettes%20and%20cracked%20mirror%20motif%2C%20deep%20crimson%20and%20charcoal%20grey%20tones%2C%20textured%20grainy%20paper%2C%20tense%20ambiguous%20mood%2C%20vertical%20poster%20art%2C%20no%20text&width=600&height=900&seq=movie-cover-12&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=moody%20city%20apartment%20window%20at%20night%20with%20rain%20and%20dim%20light%2C%20crimson%20and%20charcoal%20tones%2C%20tense%20mystery%20atmosphere%2C%20film%20grain%2C%20artistic%20wide%20shot%2C%20no%20people&width=1200&height=675&seq=movie-still-12&orientation=landscape",
    featured: false,
  },
];